import he from 'he';
import {API_URL} from 'utils/constants';

export const decodeHtmlEntities = (string?: string) => {
  let decodedString = undefined;
  if (string) {
    decodedString = he.decode(string);
  }
  return decodedString;
};

export const getAPIEndpoint = (url: string) => {
  const cleanUrl = url.replace(/^\//, '');
  return `${API_URL}/${cleanUrl}`;
};
